import {Button} from "_ui/Button";
import React from "react";
import {useDisableTwoFacto} from "_api/hooks/two-factor";
import {toastRun} from "_utils/misc";
import {toastSuccess} from "_components/ToastProvider";

export const TwoFactorEnabled = () => {
    const {mutateAsync: disable, isPending: loading} = useDisableTwoFacto();

    const onClick = async () => {
        await toastRun(
            disable(),
            () => toastSuccess('Autenticação em dois fatores desativada.'),
        )
    }
    return (
        <div>
            <h3>Autenticação em Dois Fatores</h3>

            <p>A autenticação em dois fatores já está ativada na sua conta.</p>
            <Button variant='danger' icon='fa-shield-slash' text='Desativar 2fa' {...{loading, onClick}}/>

        </div>
    );
}
